export default __webpack_public_path__ + "static/media/Y11.50db5348.jpg";